import FilterChip from 'LuxKit/Chips/FilterChip'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import React, { useCallback, useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import type { Form } from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchChips'
import ModalContext from 'contexts/ModalContext'
import ModalCruiseSearchShipChip
  from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/Modal/ModalCruiseSearchShipChip'

export interface CruiseSearchShipChipProps {
  facets: Array<App.CruiseSearchFacet>
  filters: {
    cruiseShips?: Set<string>
  }
  filterForm: Form
  setFilterForm: (form: Form) => void
  fetching?: boolean
  drawerMode?: boolean
}

function CruiseSearchShipChip(props: CruiseSearchShipChipProps) {
  const { filters, facets, filterForm, setFilterForm, fetching, drawerMode } = props
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const [countSelected, setCountSelected] = useState<number>(filters.cruiseShips?.size || 0)

  const openModal = useCallback(async() => {
    const countSelected = await showModal<number>(
      <ModalCruiseSearchShipChip
        drawerMode={drawerMode}
        facets={facets}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        fetching={fetching}
        filters={filters}
      />,
    )
    setCountSelected(countSelected)
  }, [drawerMode, facets, fetching, filterForm, filters, setFilterForm, showModal])

  const chipLabel = intl.formatMessage(
    {
      id: 'aKlLB29CIdtGPrPzjdgT',
      defaultMessage: '{count, plural, =0 {Cruise ships} one {Cruise ships (#)} other {Cruise ships (#)}}',
      description: 'Filter chip label for cruise ships with optional selected count',
    },
    { count: countSelected },
  )

  return <FilterChip
    selected={!!filters.cruiseShips?.size}
    size="medium"
    onClick={openModal}
    endIcon={<LineAngleDownIcon />}
  >
    {chipLabel}
  </FilterChip>
}

export default CruiseSearchShipChip
